// Owner-provided pricing. Edit values here to update the Pricing page.
// Source of truth: Exotic Reefing Inc "Professional Reef Services" rate sheet.
export const PRICING = {
  onetime: {
    title: "Single Home Visit (One-Time Service)",
    note: "Perfect if you just need help once. We come to you, complete the service, and get your tank back on track.",
    headers: ["Service", "Price"],
    rows: [
      ["Routine Maintenance Visit", "$100"],
      ["Water Change (up to 50 gal)", "$75"],
      ["Water Change (51–100 gal)", "$100"],
      ["Water Change (101–180 gal)", "$150"],
      ["Water Change (181–250 gal)", "$200"],
      ["Water Change (251–400 gal)", "$300"],
      ["Water Change (400+ gal)", "Custom Quote"],
      ["Nitrate / Phosphate Reduction Visit", "$125"],
      ["Algae Clean-Up", "$100–200"],
      ["Fish Health Check", "$75"],
      ["Coral Placement & Adjustment", "$75"],
      ["Parameter Testing & Report", "$50"],
      ["Equipment Check & Cleaning", "$75"],
      ["Emergency Service (Same Day)", "$150+"],
    ],
  },
  maintenance: {
    title: "Monthly Maintenance",
    note: "Recurring care to keep your reef healthy, stable and thriving — 4 visits per month. No long-term contract required. Cancel anytime.",
    headers: ["Tank size", "Monthly (4 visits)"],
    rows: [
      ["Up to 50 gal", "$249"],
      ["51–100 gal", "$399"],
      ["101–180 gal", "$599"],
      ["181–250 gal", "$799"],
      ["251–400 gal", "$1,099"],
      ["400+ gal", "Custom Quote"],
    ],
  },
  equipment: {
    title: "Equipment Installation",
    note: "Professional, clean installs. Equipment supplied separately unless quoted. Multiple installations? Ask about bundled pricing and save!",
    headers: ["Equipment", "Price"],
    rows: [
      ["Return pump", "$125"],
      ["Protein skimmer", "$125"],
      ["UV sterilizer", "$150"],
      ["Roller mat", "$175"],
      ["Wave pumps", "$50 each"],
      ["Light fixture", "$75 each"],
      ["RODI system", "$175"],
      ["ATO (auto top-off)", "$100"],
      ["Reactor", "$100"],
    ],
  },
  neptune: {
    title: "Neptune Systems",
    note: "Apex automation, programming and module setup by certified reef specialists. Custom programs available — call for details.",
    headers: ["Service", "Price"],
    rows: [
      ["Apex controller installation", "$350"],
      ["Full Apex programming", "$350–600"],
      ["Trident installation & setup", "$200"],
      ["DOS installation & setup", "$150"],
      ["Apex + Trident + DOS Complete Setup (Best value)", "$700–1,000"],
    ],
  },
  newtank: {
    title: "New Tank Installations",
    note: "Full builds — labor only. Livestock, rock, sand and equipment quoted separately. Includes plumbing, equipment setup, aquascape placement, testing & start-up.",
    headers: ["Tank size", "Labor only"],
    rows: [
      ["40–75 gal", "$450–700"],
      ["90–150 gal", "$750–1,200"],
      ["180–250 gal", "$1,500–2,400"],
      ["300+ gal", "Starting at $3,000"],
    ],
  },
};
